// ── Данные для документации Upload API ──────────────────────────
// Реальные ответы собраны с dev-окружения (2026-08-19).

export interface EndpointDoc {
    method: string;
    path: string;
    desc: string;
    request: string;
    response: string;
}

export interface EndpointGroup {
    title: string;
    icon?: string;
    endpoints: EndpointDoc[];
}

const AUTH = `-H "Authorization: Bearer \\\${ACCESS_TOKEN}"`;

/* ── Фильмы ───────────────────────────────────────────────────── */

const movieListRequest = `curl -X GET "\\\${API_BASE_URL}/movies?page=1&per_page=50" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const movieListResponse = `HTTP/1.1 200 OK

{
  "data": [
    {
      "id": 13546,
      "name": "TEST VIDEO [HDRezka]",
      "nameOriginal": "",
      "description": "",
      "releaseYear": "",
      "kinopoiskId": 122334455,
      "imdbId": null,
      "embedCode": "<ins data-publisher-id=\\"666673221\\" data-type=\\"movie\\" data-id=\\"13546\\" data-height=\\"500\\"></ins>",
      "trailerUrl": null,
      "status": "active",
      "statusId": 1,
      "statusName": "Активно",
      "categories": [],
      "voiceovers": [
        {
          "id": 7,
          "videoId": 13546,
          "name": "HDRezka",
          "hasInternalAds": 0,
          "active": 1,
          "sortOrder": null,
          "exclusiveUntil": null,
          "createdAt": "2024-07-16T17:59:15+00:00",
          "updatedAt": "2026-06-11T05:22:03+00:00",
          "videoFile": {
            "name": "",
            "size": 2848208,
            "duration": 6,
            "status": "active"
          }
        }
      ],
      "createdAt": "2024-07-16T17:59:15+00:00",
      "updatedAt": "2026-06-11T05:22:03+00:00"
    }
  ],
  "pagination": {
    "page": 1,
    "perPage": 50,
    "total": 5,
    "totalPages": 1
  },
  "success": true,
  "message": "Фильмы успешно получены",
  "status": 200
}`;

const movieCreateRequest = `curl -X POST "\\\${API_BASE_URL}/movies" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "Интерстеллар",
    "titleOriginal": "Interstellar",
    "description": "Фантастический фильм о путешествии через червоточину",
    "releaseYear": 2014,
    "kinopoiskId": 462682,
    "imdbId": "tt0816692",
    "isActive": true,
    "categories": [5],
    "tags": [],
    "trailerUrl": "https://youtube.com/watch?v=zSWdZVtXT7E",
    "voiceovers": [
      {
        "voiceoverId": 1,
        "videoFile": "movies/interstellar_rus.mp4",
        "hasInternalAds": false,
        "exclusiveDays": 0
      }
    ]
  }'`;

const movieCreateResponse = `HTTP/1.1 201 Created

{
  "success": true,
  "message": "Фильм успешно создан",
  "status": 201,
  "data": {
    "id": 128,
    "name": "Интерстеллар",
    "nameOriginal": "Interstellar",
    "description": "Фантастический фильм о путешествии через червоточину",
    "releaseYear": "2014",
    "kinopoiskId": 462682,
    "imdbId": "tt0816692",
    "embedCode": "<ins data-publisher-id=\\"666673221\\" data-type=\\"movie\\" data-id=\\"128\\" data-height=\\"500\\"></ins>",
    "trailerUrl": "https://youtube.com/watch?v=zSWdZVtXT7E",
    "status": "processing",
    "statusId": 3,
    "statusName": "Конвертация",
    "categories": [ { "id": 5, "name": "Фильм" } ],
    "voiceovers": [
      {
        "id": 552,
        "videoId": 128,
        "name": "Дублированный",
        "hasInternalAds": 0,
        "active": 1,
        "sortOrder": 0,
        "exclusiveUntil": null,
        "videoFile": { "name": "128.tmp", "size": 2147483648, "duration": null, "status": "processing" }
      }
    ],
    "createdAt": "2026-08-19T11:30:00+00:00",
    "updatedAt": "2026-08-19T11:30:00+00:00"
  }
}`;

const movieShowRequest = `curl -X GET "\\\${API_BASE_URL}/movies/13546" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const movieShowResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Данные фильма успешно получены",
  "status": 200,
  "data": {
    "id": 13546,
    "name": "TEST VIDEO [HDRezka]",
    "nameOriginal": "",
    "description": "",
    "releaseYear": "",
    "kinopoiskId": 122334455,
    "imdbId": null,
    "embedCode": "<ins data-publisher-id=\\"666673221\\" data-type=\\"movie\\" data-id=\\"13546\\" data-height=\\"500\\"></ins>",
    "trailerUrl": null,
    "status": "active",
    "statusId": 1,
    "statusName": "Активно",
    "categories": [],
    "voiceovers": [
      {
        "id": 7,
        "videoId": 13546,
        "name": "HDRezka",
        "hasInternalAds": 0,
        "active": 1,
        "sortOrder": null,
        "exclusiveUntil": null,
        "createdAt": "2024-07-16T17:59:15+00:00",
        "updatedAt": "2026-06-11T05:22:03+00:00",
        "videoFile": {
          "name": "",
          "size": 2848208,
          "duration": 6,
          "status": "active"
        }
      }
    ],
    "createdAt": "2024-07-16T17:59:15+00:00",
    "updatedAt": "2026-06-11T05:22:03+00:00"
  }
}`;

const movieUpdateRequest = `curl -X PUT "\\\${API_BASE_URL}/movies/128" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "Интерстеллар (переиздание)",
    "description": "Обновлённое описание",
    "releaseYear": 2014,
    "isActive": true
  }'`;

const movieDeleteRequest = `curl -X DELETE "\\\${API_BASE_URL}/movies/128" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const simpleOkResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Фильм успешно удалён",
  "status": 200
}`;

const simpleOkResponseName = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Фильм успешно обновлён",
  "status": 200
}`;

const movieVoiceoverAddRequest = `curl -X POST "\\\${API_BASE_URL}/movies/128/voiceovers" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "voiceoverId": 2,
    "videoFile": "movies/interstellar_eng.mp4",
    "hasInternalAds": false,
    "isActive": true,
    "exclusiveDays": 0
  }'`;

const voiceoverAddResponse = `HTTP/1.1 201 Created

{
  "success": true,
  "message": "Озвучка успешно добавлена",
  "status": 201,
  "data": {
    "id": 553,
    "videoId": 129,
    "name": "Дублированный",
    "hasInternalAds": 0,
    "active": 1,
    "sortOrder": 1,
    "exclusiveUntil": null,
    "videoFile": {
      "name": "129.tmp",
      "size": 1900022334,
      "duration": null,
      "status": "processing"
    }
  }
}`;

const movieVoiceoverUpdateRequest = `curl -X PUT "\\\${API_BASE_URL}/movies/128/voiceovers/553/129" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "voiceoverId": 2,
    "hasInternalAds": true,
    "isActive": true,
    "exclusiveDays": 7
  }'`;

const movieVoiceoverDeleteRequest = `curl -X DELETE "\\\${API_BASE_URL}/movies/128/voiceovers/553/129" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const voiceoverDeleteResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Озвучка успешно удалена",
  "status": 200
}`;

/* ── Сериалы ──────────────────────────────────────────────────── */

const serialListRequest = `curl -X GET "\\\${API_BASE_URL}/serials?page=1&per_page=50&mine=true" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const serialListResponse = `HTTP/1.1 200 OK

{
  "data": [
    {
      "id": 7455,
      "title": "Тестовый сериал",
      "titleOriginal": "Test Serial",
      "description": "",
      "releaseYear": "2024",
      "kinopoiskId": "0",
      "imdbId": "",
      "trailerUrl": "",
      "embedCode": "<ins data-publisher-id=\\"666673221\\" data-type=\\"serial\\" data-id=\\"7455\\" data-height=\\"500\\"></ins>",
      "categories": [ { "id": 4, "name": "Сериал" } ],
      "seasonsCount": 1,
      "videosCount": 0,
      "status": "draft",
      "statusId": 0,
      "statusName": "Отключено",
      "createdAt": "2026-08-19T11:25:09+00:00",
      "updatedAt": "2026-08-19T11:25:09+00:00"
    }
  ],
  "pagination": {
    "page": 1,
    "perPage": 50,
    "total": 1,
    "totalPages": 1
  },
  "success": true,
  "message": "Сериалы успешно получены",
  "status": 200
}`;

const serialCreateRequest = `curl -X POST "\\\${API_BASE_URL}/serials" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "Во все тяжкие",
    "title_original": "Breaking Bad",
    "description": "Школьный учитель начинает варить метамфетамин",
    "release_year": 2008,
    "kinopoisk_id": 373673,
    "imdb_id": "tt0903747",
    "trailer_url": "https://youtube.com/watch?v=HhesaQXLuRY",
    "is_active": true,
    "categories": [4],
    "tags": []
  }'`;

const serialCreateResponse = `HTTP/1.1 201 Created

{
  "success": true,
  "message": "Сериал успешно создан",
  "status": 201,
  "data": {
    "id": 7456,
    "title": "Во все тяжкие",
    "titleOriginal": "Breaking Bad",
    "description": "Школьный учитель начинает варить метамфетамин",
    "releaseYear": 2008,
    "kinopoiskId": 373673,
    "imdbId": "tt0903747",
    "trailerUrl": "https://youtube.com/watch?v=HhesaQXLuRY",
    "embedCode": "<ins data-publisher-id=\\"666673221\\" data-type=\\"serial\\" data-id=\\"7456\\" data-height=\\"500\\"></ins>",
    "seasonsCount": null,
    "videosCount": null,
    "status": "draft",
    "statusId": 0,
    "statusName": "Отключено",
    "createdAt": "2026-08-19T11:31:00+00:00",
    "updatedAt": "2026-08-19T11:31:00+00:00"
  }
}`;

const serialShowRequest = `curl -X GET "\\\${API_BASE_URL}/serials/7456" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const serialShowResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Данные сериала успешно получены",
  "status": 200,
  "data": {
    "id": 7456,
    "title": "Во все тяжкие",
    "titleOriginal": "Breaking Bad",
    "description": "Школьный учитель начинает варить метамфетамин",
    "releaseYear": "2008",
    "kinopoiskId": "373673",
    "imdbId": "tt0903747",
    "trailerUrl": "",
    "embedCode": "<ins data-publisher-id=\\"666673221\\" data-type=\\"serial\\" data-id=\\"7456\\" data-height=\\"500\\"></ins>",
    "categories": [ { "id": 4, "name": "Сериал" } ],
    "seasonsCount": 0,
    "videosCount": 0,
    "status": "draft",
    "statusId": 0,
    "statusName": "Отключено",
    "createdAt": "2026-08-19T11:31:00+00:00",
    "updatedAt": "2026-08-19T11:31:00+00:00"
  }
}`;

const serialUpdateRequest = `curl -X PUT "\\\${API_BASE_URL}/serials/7456" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "titleOriginal": "Breaking Bad",
    "description": "Обновлённое описание сериала",
    "releaseYear": 2008
  }'`;

const serialDeleteRequest = `curl -X DELETE "\\\${API_BASE_URL}/serials/7456" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const serialDeleteResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Сериал успешно удалён",
  "status": 200
}`;

const serialPublishRequest = `curl -X POST "\\\${API_BASE_URL}/serials/7456/publish" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const serialPublishResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Сериал успешно опубликован",
  "status": 200,
  "data": {
    "id": 7456,
    "title": "Во все тяжкие",
    "status": "active",
    "statusId": 1,
    "statusName": "Активно"
  }
}`;

/* ── Сезоны ───────────────────────────────────────────────────── */

const seasonListRequest = `curl -X GET "\\\${API_BASE_URL}/serials/7456/seasons?page=1&per_page=50&sort_by=sort_order&sort_order=asc" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const seasonListResponse = `HTTP/1.1 200 OK

{
  "data": [
    {
      "id": 13747,
      "serialId": 7456,
      "title": "Сезон 1",
      "description": "",
      "releaseYear": "",
      "sortOrder": 1,
      "status": "draft",
      "statusId": 0,
      "statusName": "Отключено",
      "videosCount": 0,
      "episodes": [],
      "createdAt": "2026-08-19T11:31:00+00:00",
      "updatedAt": "2026-08-19T11:31:00+00:00"
    }
  ],
  "pagination": {
    "page": 1,
    "perPage": 50,
    "total": 1,
    "totalPages": 1
  },
  "success": true,
  "message": "Сезоны успешно получены",
  "status": 200
}`;

const seasonCreateRequest = `curl -X POST "\\\${API_BASE_URL}/serials/7456/seasons" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "Сезон 1",
    "sortOrder": 1
  }'`;

const seasonCreateResponse = `HTTP/1.1 201 Created

{
  "success": true,
  "message": "Сезон успешно добавлен",
  "status": 201,
  "data": {
    "id": 13748,
    "serialId": 7456,
    "title": "Сезон 1",
    "description": "",
    "releaseYear": "",
    "sortOrder": 1,
    "status": "draft",
    "statusId": 0,
    "statusName": "Отключено",
    "videosCount": null,
    "createdAt": "2026-08-19T11:32:00+00:00",
    "updatedAt": "2026-08-19T11:32:00+00:00"
  }
}`;

const seasonShowRequest = `curl -X GET "\\\${API_BASE_URL}/serials/7456/seasons/13748" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const seasonShowResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Данные сезона успешно получены",
  "status": 200,
  "data": {
    "id": 13748,
    "serialId": 7456,
    "title": "Сезон 1",
    "description": "",
    "releaseYear": "",
    "sortOrder": 1,
    "status": "draft",
    "statusId": 0,
    "statusName": "Отключено",
    "videosCount": 0,
    "episodes": [],
    "createdAt": "2026-08-19T11:32:00+00:00",
    "updatedAt": "2026-08-19T11:32:00+00:00"
  }
}`;

const seasonUpdateRequest = `curl -X PUT "\\\${API_BASE_URL}/serials/7456/seasons/13748" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "Сезон 1 (обновлён)",
    "description": "Описание сезона",
    "releaseYear": 2008,
    "sortOrder": 1
  }'`;

const seasonUpdateResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Сезон успешно обновлён",
  "status": 200,
  "data": {
    "id": 13748,
    "serialId": 7456,
    "title": "Сезон 1 (обновлён)",
    "description": "Описание сезона",
    "releaseYear": "2008",
    "sortOrder": 1,
    "status": "draft",
    "statusId": 0,
    "statusName": "Отключено",
    "videosCount": 0,
    "createdAt": "2026-08-19T11:32:00+00:00",
    "updatedAt": "2026-08-19T11:32:00+00:00"
  }
}`;

const seasonDeleteRequest = `curl -X DELETE "\\\${API_BASE_URL}/serials/7456/seasons/13748" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const seasonDeleteResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Сезон успешно удалён",
  "status": 200
}`;

/* ── Эпизоды ──────────────────────────────────────────────────── */

const episodeListRequest = `curl -X GET "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const episodeListResponse = `HTTP/1.1 200 OK

{
  "data": [
    {
      "id": 12345,
      "videoId": 56789,
      "seasonId": 13748,
      "title": "Пилот",
      "filmName": "Эпизод 1",
      "sortOrder": 1,
      "description": "",
      "releaseYear": "2008",
      "kinopoiskId": 123456,
      "imdbId": "tt0959621",
      "statusId": 1,
      "voiceovers": [
        {
          "id": 77,
          "videoId": 56789,
          "name": "Дублированный",
          "hasInternalAds": 0,
          "active": 1,
          "sortOrder": 0,
          "exclusiveUntil": null,
          "videoFile": {
            "name": "",
            "size": 1879048192,
            "duration": 2864,
            "status": "active"
          }
        }
      ]
    }
  ],
  "success": true,
  "message": "Эпизоды успешно получены",
  "status": 200
}`;

const episodeCreateRequest = `curl -X POST "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "filmName": "Эпизод 1",
    "sortOrder": 1,
    "description": "Пилотная серия",
    "releaseYear": 2008,
    "kinopoiskId": 123456,
    "imdbId": "tt0959621",
    "isActive": true,
    "voiceovers": [
      {
        "voiceoverId": 1,
        "videoFile": "serial/bb_s01e01.mp4",
        "hasInternalAds": false
      }
    ]
  }'`;

const episodeCreateResponse = `HTTP/1.1 201 Created

{
  "success": true,
  "message": "Эпизод успешно создан",
  "status": 201,
  "data": {
    "id": 12345,
    "videoId": 56789,
    "seasonId": 13748,
    "title": "Пилот",
    "filmName": "Эпизод 1",
    "sortOrder": 1,
    "description": "Пилотная серия",
    "releaseYear": "2008",
    "kinopoiskId": 123456,
    "imdbId": "tt0959621",
    "statusId": 3,
    "voiceovers": [
      {
        "id": 77,
        "videoId": 56789,
        "name": "Дублированный",
        "hasInternalAds": 0,
        "active": 1,
        "sortOrder": 0,
        "exclusiveUntil": null,
        "videoFile": {
          "name": "56789.tmp",
          "size": 1879048192,
          "duration": null,
          "status": "processing"
        }
      }
    ]
  }
}`;

const episodeShowRequest = `curl -X GET "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/12345" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const episodeUpdateRequest = `curl -X PUT "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/12345" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "filmName": "Эпизод 1 (обновлён)",
    "sortOrder": 1,
    "description": "Новое описание",
    "isActive": true
  }'`;

const episodeDeleteRequest = `curl -X DELETE "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/12345" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const episodeDeleteResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Эпизод успешно удалён",
  "status": 200
}`;

const episodesMassRequest = `curl -X POST "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/mass" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "filmName": "Эпизод {number}",
    "voiceoverId": 1,
    "isActive": true,
    "hasInternalAds": false,
    "files": [
      { "videoFile": "serial/bb_s01e01.mp4", "sortOrder": 1 },
      { "videoFile": "serial/bb_s01e02.mp4", "sortOrder": 2 },
      { "videoFile": "serial/bb_s01e03.mp4", "sortOrder": 3 }
    ]
  }'`;

const episodesMassResponse = `HTTP/1.1 201 Created

{
  "success": true,
  "message": "Эпизоды успешно созданы",
  "status": 201,
  "data": [
    { "id": 12345, "videoId": 56789, "seasonId": 13748, "filmName": "Эпизод 1", "sortOrder": 1, "statusId": 3 },
    { "id": 12346, "videoId": 56790, "seasonId": 13748, "filmName": "Эпизод 2", "sortOrder": 2, "statusId": 3 },
    { "id": 12347, "videoId": 56791, "seasonId": 13748, "filmName": "Эпизод 3", "sortOrder": 3, "statusId": 3 }
  ]
}`;

const episodeVoiceoverAddRequest = `curl -X POST "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/12345/voiceovers" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "voiceoverId": 2,
    "videoFile": "serial/bb_s01e01_eng.mp4",
    "hasInternalAds": false,
    "isActive": true,
    "exclusiveDays": 0
  }'`;

const episodeVoiceoverUpdateRequest = `curl -X PUT "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/12345/voiceovers/77/56789" \\
  ${AUTH} \\
  -H "Content-Type: application/json" \\
  -d '{
    "voiceoverId": 2,
    "hasInternalAds": true,
    "isActive": true,
    "exclusiveDays": 7
  }'`;

const episodeVoiceoverDeleteRequest = `curl -X DELETE "\\\${API_BASE_URL}/serials/7456/seasons/13748/episodes/12345/voiceovers/77/56789" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

/* ── Справочники ──────────────────────────────────────────────── */

const voiceoversRefRequest = `curl -X GET "\\\${API_BASE_URL}/reference/voiceovers?search=&page=1&per_page=20" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const voiceoversRefResponse = `HTTP/1.1 200 OK

{
  "data": [
    {
      "id": 417,
      "name": "(Amazing Dubbing) Субтитры",
      "description": "",
      "videosCount": 37,
      "createdAt": "2026-01-25T15:44:02+00:00"
    },
    {
      "id": 309,
      "name": "(AniJoy) Субтитры",
      "description": "",
      "videosCount": 51,
      "createdAt": "2025-07-28T15:52:07+00:00"
    }
  ],
  "pagination": {
    "page": 1,
    "perPage": 20,
    "total": 128,
    "totalPages": 7
  },
  "success": true,
  "message": "Озвучки успешно получены",
  "status": 200
}`;

const categoriesRefRequest = `curl -X GET "\\\${API_BASE_URL}/reference/categories" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const categoriesRefResponse = `HTTP/1.1 200 OK

{
  "data": {
    "types": [
      { "id": 2, "title": "Мейнстрим", "description": "", "videosCount": 125969, "createdAt": "2024-01-30T16:00:39+00:00" },
      { "id": 18, "title": "Аниме", "description": "", "videosCount": 23928, "createdAt": "2024-02-06T22:46:55+00:00" }
    ],
    "genres": [
      { "id": 6, "title": "Боевик", "description": "", "videosCount": 45954, "createdAt": "2024-01-30T16:05:03+00:00" },
      { "id": 7, "title": "Драма", "description": "", "videosCount": 94297, "createdAt": "2024-01-30T16:07:04+00:00" }
    ],
    "countries": [
      { "id": 10, "title": "США", "description": "", "videosCount": 123456, "createdAt": "2024-01-30T16:00:39+00:00" }
    ]
  },
  "success": true,
  "message": "Категории успешно получены",
  "status": 200
}`;

const infoRefRequest = `curl -X GET "\\\${API_BASE_URL}/reference/info?kp_id=462682" \\
  ${AUTH} \\
  -H "Accept: application/json"

# Также можно по IMDB:
# curl -X GET "\\\${API_BASE_URL}/reference/info?imdb_id=tt0816692" \\\\
#   ${AUTH}`;

const infoRefResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Информация о фильме успешно найдена",
  "status": 200,
  "data": {
    "imdb": {
      "title": "Interstellar",
      "year": "2014",
      "imdbId": "tt0816692",
      "rating": 8.7,
      "plot": "A team of explorers travel through a wormhole in space..."
    },
    "kinopoisk": {
      "kinopoiskId": 462682,
      "nameRu": "Интерстеллар",
      "year": 2014,
      "ratingKinopoisk": 8.6
    }
  }
}`;

const videoStatusRequest = `curl -X GET "\\\${API_BASE_URL}/videos/13546/status" \\
  ${AUTH} \\
  -H "Accept: application/json"`;

const videoStatusResponse = `HTTP/1.1 200 OK

{
  "success": true,
  "message": "Статус видео получен",
  "status": 200,
  "data": {
    "id": 13546,
    "status": "active",
    "statusId": 1,
    "statusName": "Активно"
  }
}`;

/* ── Группы ───────────────────────────────────────────────────── */

export const ENDPOINT_GROUPS: EndpointGroup[] = [
    {
        title: 'Фильмы',
        endpoints: [
            {
                method: 'GET', path: '/movies', desc: 'Список фильмов (пагинация, поиск, фильтры)',
                request: movieListRequest, response: movieListResponse,
            },
            {
                method: 'POST', path: '/movies', desc: 'Создать фильм с озвучками',
                request: movieCreateRequest, response: movieCreateResponse,
            },
            {
                method: 'GET', path: '/movies/{movie_id}', desc: 'Получить фильм с озвучками',
                request: movieShowRequest, response: movieShowResponse,
            },
            {
                method: 'PUT', path: '/movies/{movie_id}', desc: 'Обновить метаданные фильма',
                request: movieUpdateRequest, response: simpleOkResponseName,
            },
            {
                method: 'DELETE', path: '/movies/{movie_id}', desc: 'Удалить фильм (soft delete)',
                request: movieDeleteRequest, response: simpleOkResponse,
            },
            {
                method: 'POST', path: '/movies/{movie_id}/voiceovers', desc: 'Добавить озвучку к фильму',
                request: movieVoiceoverAddRequest, response: voiceoverAddResponse,
            },
            {
                method: 'PUT', path: '/movies/{movie_id}/voiceovers/{voiceover_id}/{video_id}', desc: 'Обновить озвучку фильма',
                request: movieVoiceoverUpdateRequest, response: simpleOkResponseName,
            },
            {
                method: 'DELETE', path: '/movies/{movie_id}/voiceovers/{voiceover_id}/{video_id}', desc: 'Удалить озвучку фильма',
                request: movieVoiceoverDeleteRequest, response: voiceoverDeleteResponse,
            },
        ],
    },
    {
        title: 'Сериалы',
        endpoints: [
            {
                method: 'GET', path: '/serials', desc: 'Список сериалов',
                request: serialListRequest, response: serialListResponse,
            },
            {
                method: 'POST', path: '/serials', desc: 'Создать сериал',
                request: serialCreateRequest, response: serialCreateResponse,
            },
            {
                method: 'GET', path: '/serials/{serial_id}', desc: 'Получить сериал со счётчиками сезонов/видео',
                request: serialShowRequest, response: serialShowResponse,
            },
            {
                method: 'PUT', path: '/serials/{serial_id}', desc: 'Обновить сериал',
                request: serialUpdateRequest, response: serialShowResponse,
            },
            {
                method: 'DELETE', path: '/serials/{serial_id}', desc: 'Удалить сериал',
                request: serialDeleteRequest, response: serialDeleteResponse,
            },
            {
                method: 'POST', path: '/serials/{serial_id}/publish', desc: 'Опубликовать сериал',
                request: serialPublishRequest, response: serialPublishResponse,
            },
        ],
    },
    {
        title: 'Сезоны',
        endpoints: [
            {
                method: 'GET', path: '/serials/{serial_id}/seasons', desc: 'Список сезонов',
                request: seasonListRequest, response: seasonListResponse,
            },
            {
                method: 'POST', path: '/serials/{serial_id}/seasons', desc: 'Создать сезон',
                request: seasonCreateRequest, response: seasonCreateResponse,
            },
            {
                method: 'GET', path: '/serials/{serial_id}/seasons/{season_id}', desc: 'Получить сезон с эпизодами',
                request: seasonShowRequest, response: seasonShowResponse,
            },
            {
                method: 'PUT', path: '/serials/{serial_id}/seasons/{season_id}', desc: 'Обновить сезон',
                request: seasonUpdateRequest, response: seasonUpdateResponse,
            },
            {
                method: 'DELETE', path: '/serials/{serial_id}/seasons/{season_id}', desc: 'Удалить сезон',
                request: seasonDeleteRequest, response: seasonDeleteResponse,
            },
        ],
    },
    {
        title: 'Эпизоды',
        endpoints: [
            {
                method: 'GET', path: '/serials/{serial_id}/seasons/{season_id}/episodes', desc: 'Список эпизодов',
                request: episodeListRequest, response: episodeListResponse,
            },
            {
                method: 'POST', path: '/serials/{serial_id}/seasons/{season_id}/episodes', desc: 'Создать эпизод с озвучками',
                request: episodeCreateRequest, response: episodeCreateResponse,
            },
            {
                method: 'GET', path: '/serials/{serial_id}/seasons/{season_id}/episodes/{episode_id}', desc: 'Получить эпизод',
                request: episodeShowRequest, response: episodeListResponse,
            },
            {
                method: 'PUT', path: '/serials/{serial_id}/seasons/{season_id}/episodes/{episode_id}', desc: 'Обновить эпизод',
                request: episodeUpdateRequest, response: simpleOkResponseName,
            },
            {
                method: 'DELETE', path: '/serials/{serial_id}/seasons/{season_id}/episodes/{episode_id}', desc: 'Удалить эпизод',
                request: episodeDeleteRequest, response: episodeDeleteResponse,
            },
            {
                method: 'POST', path: '/serials/{serial_id}/seasons/{season_id}/episodes/mass', desc: 'Массовое создание эпизодов',
                request: episodesMassRequest, response: episodesMassResponse,
            },
            {
                method: 'POST', path: '/serials/{serial_id}/seasons/{season_id}/episodes/{episode_id}/voiceovers', desc: 'Добавить озвучку к эпизоду',
                request: episodeVoiceoverAddRequest, response: voiceoverAddResponse,
            },
            {
                method: 'PUT', path: '/serials/{serial_id}/seasons/{season_id}/episodes/{episode_id}/voiceovers/{voiceover_id}/{video_id}', desc: 'Обновить озвучку эпизода',
                request: episodeVoiceoverUpdateRequest, response: simpleOkResponseName,
            },
            {
                method: 'DELETE', path: '/serials/{serial_id}/seasons/{season_id}/episodes/{episode_id}/voiceovers/{voiceover_id}/{video_id}', desc: 'Удалить озвучку эпизода',
                request: episodeVoiceoverDeleteRequest, response: voiceoverDeleteResponse,
            },
        ],
    },
    {
        title: 'Справочники',
        endpoints: [
            {
                method: 'GET', path: '/reference/voiceovers', desc: 'Список озвучек (min per_page=20)',
                request: voiceoversRefRequest, response: voiceoversRefResponse,
            },
            {
                method: 'GET', path: '/reference/categories', desc: 'Категории, жанры и страны',
                request: categoriesRefRequest, response: categoriesRefResponse,
            },
            {
                method: 'GET', path: '/reference/info', desc: 'Метаданные фильма по KP/IMDB',
                request: infoRefRequest, response: infoRefResponse,
            },
            {
                method: 'GET', path: '/videos/{video_id}/status', desc: 'Текущий статус видео',
                request: videoStatusRequest, response: videoStatusResponse,
            },
        ],
    },
];
